import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import _Number$isInteger from "@babel/runtime-corejs3/core-js-stable/number/is-integer";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import React, { useEffect, useState } from 'react';
import Range from 'rc-slider';
import 'rc-slider/assets/index.css';
import colors from "../../../utils/colors";


import useFirstRender from "../../../hooks/useFirstRender";
import { useDebounce } from "../../../hooks/useDebounce";
import { createStyles } from "./style";

var RangeSlider = function RangeSlider(_ref)










{var _context, _context2;var title = _ref.title,min = _ref.min,max = _ref.max,step = _ref.step,_ref$defaultValues = _ref.defaultValues,defaultValues = _ref$defaultValues === void 0 ? null : _ref$defaultValues,_ref$hasSmallView = _ref.hasSmallView,hasSmallView = _ref$hasSmallView === void 0 ? false : _ref$hasSmallView,shouldBeReset = _ref.shouldBeReset,defaultFilters = _ref.defaultFilters,defaultRateRange = _ref.defaultRateRange,onRangeChange = _ref.onRangeChange;
  var classes = createStyles();
  // Change visually value in range
  var isDefaultFilterDefined =
  defaultFilters && defaultFilters[title] ? defaultFilters[title] : [min, max];

  var _useState = useState(defaultRateRange || isDefaultFilterDefined),_useState2 = _slicedToArray(_useState, 2),sliderValues = _useState2[0],setSliderValues = _useState2[1];
  // as component is controlled , onAfterChange method does not work,
  // so hook useDebounce is used for sending selected values to page component not at once, but in 500ms
  var debouncedValue = useDebounce(sliderValues, 500);
  var firstRender = useFirstRender();

  var onSliderChange = function onSliderChange(values) {
    setSliderValues([values[0], values[1]]);
  };

  useEffect(function () {
    if (!firstRender) onRangeChange(title, [debouncedValue[0], debouncedValue[1]]); // update in all selected filter options object
  }, [debouncedValue]);

  useEffect(function () {
    if (shouldBeReset) {
      setSliderValues([min, max]); // update in state
    }
  }, [shouldBeReset]);

  var createMarks = function createMarks() {
    var stepsCount = step && (max - min) / step;
    var steps = stepsCount && Math.floor(stepsCount);
    var marksObject = {};

    if (step && steps && steps <= 5) {
      // eslint-disable-next-line no-plusplus
      for (var i = 0, j = min; i <= steps; i++, j += step) {
        // hide last mark and show max value if stepsCount is not integer
        if (_Number$isInteger(stepsCount) || !_Number$isInteger(stepsCount) && i !== steps) {
          marksObject[j] = j;
        }
        marksObject[max] = max;
      }
      // there are no space for more than 5 marks, so show first and last
    } else {
      marksObject[min] = min;
      marksObject[max] = max;
    }
    return marksObject;
  };

  var RangeComponent = /*#__PURE__*/
  React.createElement(Range, {
    range: true,
    allowCross: false,
    defaultValue: defaultValues || [min, max],
    value: sliderValues // component is controlled, so it changes when value changes
    , min: min,
    max: max,
    dots: !!(step && step > 1),
    marks: createMarks(),
    step: step || 1,
    onChange: onSliderChange,
    className: classes.range,
    trackStyle: { backgroundColor: colors.blue[600] },
    railStyle: { backgroundColor: colors.neutral[300] },
    activeDotStyle: { borderColor: colors.blue[600] } });


  return /*#__PURE__*/(
    React.createElement("div", { className: classes.sliderWrapper },

    hasSmallView ? /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    React.createElement("div", { className: classes.rangeSmallViewTitle }, /*#__PURE__*/
    React.createElement("p", { className: classes.sliderTitle }, title), /*#__PURE__*/
    React.createElement("p", { className: classes.rangeValues }, _concatInstanceProperty(_context = "$".concat(sliderValues[0], " - $")).call(_context, sliderValues[1]))), /*#__PURE__*/

    React.createElement("div", { className: classes.slider }, RangeComponent)) : /*#__PURE__*/


    React.createElement(React.Fragment, null, /*#__PURE__*/
    React.createElement("p", { className: classes.sliderTitle }, title), /*#__PURE__*/
    React.createElement("div", { className: classes.slider }, /*#__PURE__*/
    React.createElement("p", { className: classes.rangeValues }, _concatInstanceProperty(_context2 = "$".concat(sliderValues[0], " - $")).call(_context2, sliderValues[1])),
    RangeComponent))));





};

export default RangeSlider;
//# sourceMappingURL=index.js.map